Vue.component('ack-become-our-distributor', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-become-our-distributor',
	mixins: [languageMixins],
	created() {},
	mounted() {},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'become-our-distributor-page',
		};
	},
	methods: {
		// ...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
